import React, { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'

interface DocumentsDropzoneProps {
  fileDropped: (files: FileList) => void
}

export function DocumentsDropzone(props: DocumentsDropzoneProps) {
  const [dragging, setDragging] = useState(false)
  const drop = useRef<HTMLDivElement | null>(null)
  const { t } = useTranslation()

  const handleDragEnter = (e: React.DragEvent) => {
    e.preventDefault()
    e.stopPropagation()
    if (e.target !== drop.current) {
      setDragging(true)
    }
  }

  const handleDragLeave = (e: React.DragEvent) => {
    e.preventDefault()
    e.stopPropagation()
    if (e.target === drop.current) {
      setDragging(false)
    }
  }

  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault()
    e.stopPropagation()
  }

  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault()
    e.stopPropagation()
    setDragging(false)
    if (e.dataTransfer?.files && e.dataTransfer.files.length > 0) {
      props.fileDropped(e.dataTransfer.files)
    }
  }

  return (
    <div className="vehicleDocumentsDropzoneComponent">
      <div className="box-title">
        <span>
          <i className="icon-upload"></i> {t('FILE_UPLOAD')}
        </span>
      </div>
      <div
        ref={drop}
        onDragOver={(e) => handleDragOver(e)}
        onDrop={(e) => handleDrop(e)}
        onDragEnter={(e) => handleDragEnter(e)}
        onDragLeave={(e) => handleDragLeave(e)}
        className="box2"
      >
        <div className={dragging ? 'dropArea draggingActive' : 'dropArea'}>
          <input style={{ display: 'none' }} type="file" />
          <div className="drop">
            <i className="icon-upload"></i>
            <p className="textBig">{t('DRAG_AND_DROP_YOUR_FILE')}</p>
          </div>
        </div>
      </div>
    </div>
  )
}
